import { useEffect, useState } from "react";
import { DonorService } from "../../../Services/Donor.Service";
import { AdminService } from "../../../Services/Admin.service";
import Toaster from "../../../Components/Toaster";
import { FaClock } from "react-icons/fa";
import { Table } from "react-bootstrap";
import SampleTypeDropdown from "../../../Components/AdministrativeSettings/SampleTypeDropdown";
import LoadingComponent from "../../../Components/LoadingComponent";
import NoListDataAvailable from "../../../Components/NoListDataAvailable";
import TablePagination from "../../../Components/AdministrativeSettings/TablePagination";
import UpcomingDonationsTableRow from "../../../Components/AdministrativeSettings/DonorManagement/UpcomingDonationsTableRow";
import DateRangeFilter from "../../../Components/AdministrativeSettings/DateRangeFilter";
import NumberOfDonationSort from "../../../Components/AdministrativeSettings/NumberOfDonartionSort";
import SearchInput from "../../../Components/AdministrativeSettings/SearchInput";
import LabLocationDropdown from "../../../Components/AdministrativeSettings/LabLocationDropdown";
import DonationHistoryTableRow from "../../../Components/AdministrativeSettings/DonorManagement/DonationHistoryTableRow";
import Loader from "../../../Components/Loader";
import TokenService from "../../../Services/Token.service";
function DonationHistoryListTable(props) {
    const [loading, setLoading] = useState(true);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [totalUpcomingDonations, setTotalUpcomingDonation] = useState(0);
    const [UpcomingDonationList, setUpcomingDonationList] = useState([]);

    const [samples, setSamples] = useState([]);
    const [selectedSamples, setSelectedSamples] = useState([]);

    const [donationStatus, setDonationStatus] = useState([]);
    const [selectedDonationStatus, setSelectedDonationStatus] = useState([]);

    const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
    const [timeSortDirection, setTimeSortDirection] = useState(null);

    const [compensationSortDirection, setCompensationSortDirection] = useState(null);

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, offset: 0 });

    const [searchJob, setSearchJob] = useState("");
    const [isSearchInputVisible, setSearchInputVisible] = useState(false);

    const [searchDonorName, setSearchDonorName] = useState("");
    const [isSearchDonorNameInputVisible, setSearchDonorNameInputVisible] = useState(false);


    const { isClearFilter } = props;
    const { onFilterCountChange } = props;
    const { exportCsv } = props;
    const {userType} = props;
    const {donorId} = props;

    useEffect(() => {
        if (isClearFilter) {
            setSelectedSamples([]);
            setSearchJob("");
            setSearchDonorName("");
            setSearchInputVisible(false);
            setSearchDonorNameInputVisible(false);
            onFilterCountChange(0);
            setSelectedDonationStatus([]);
            setSelectedDateRange([null, null]);
            setTimeSortDirection(null);
            setCompensationSortDirection(null);
        }
    }, [isClearFilter]);

    // Calculate and update the filter count
    useEffect(() => {
        const count = [
            selectedSamples.length > 0 ? 1 : 0,
            timeSortDirection !== null ? 1 : 0,
            compensationSortDirection !== null ? 1 : 0,
            selectedDonationStatus.length > 0 ? 1 : 0,
            searchJob ? 1 : 0,
            searchDonorName ? 1 : 0,
            // selectedDateRange.length > 0 ? 1 : 0, 
            selectedDateRange[0] !== null && selectedDateRange[1] !== null ? 1 : 0,
        ].reduce((sum, val) => sum + val, 0);

        onFilterCountChange(count);
    }, [searchJob,searchDonorName, selectedSamples, selectedDonationStatus, selectedDateRange, timeSortDirection, compensationSortDirection]);

    useEffect(() => {
        if (exportCsv) {

            setLoading(true);
           
            const filters = {
                from_date : selectedDateRange[0], 
                to_date : selectedDateRange[1], 
                job_id : searchJob,
                name: searchDonorName,
                samples: selectedSamples.map(sample => Number(sample)),
                status: selectedDonationStatus,
            };
            const userId = donorId || TokenService.getUserId();
            const params = {
                limit: pagination.limit,
                offset: pagination.offset,
                ...(userType !== "donation_report" && { donor_id: userId }),
                export_type:  userType == "donor" ?  "donor_donation"  : userType == "donor_view_donation" ?  userType : "donation_report",
                filters: filters,                
                sort: { 
                    ...((timeSortDirection  || compensationSortDirection ) &&  {   appointment_time: timeSortDirection,
                        total_price: compensationSortDirection  }),                 
                },
            };
            DonorService.exportDonationHistoryList(params)
                .then((response) => {
                    if (response.success) {
                        setShowToast(true);
                        setToastMessage(response.message);
                        setToastVariant("success");
                        const downloadUrl = response.download_url;
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        // link.setAttribute('download', 'DonationHistory_export.csv');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setLoading(false);
                    } else {
                        setShowToast(true);
                        setToastMessage(response.message);
                        setToastVariant("danger");
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    setShowToast(true);
                    setToastMessage("Error exporting Donation History list.");
                    setToastVariant("danger");
                    console.error("Error exporting Donation History list:", error);
                    setLoading(false);
                });
        }
    }, [exportCsv]);


    useEffect(() => {
        fetchSampleTypes();
        fetchDonationStatus();
    }, []);

    useEffect(() => {
   
        fetchUpcomingDonationList();
    }, [pagination, searchJob, searchDonorName, selectedSamples, selectedDonationStatus, selectedDateRange, timeSortDirection, compensationSortDirection]);
    //   selectedRoles, searchEmail, searchPhone, searchId

    function fetchUpcomingDonationList() {
        setLoading(true);
        const filters = {

            from_date : selectedDateRange[0], 
            to_date : selectedDateRange[1], 
            job_id : searchJob,
            name: searchDonorName,
            samples: selectedSamples.map(sample => Number(sample)),
            status: selectedDonationStatus,
        };
        const userId =  donorId || TokenService.getUserId();
        const params = {
            limit: pagination.limit,
            offset: pagination.offset,            
            ...(userType !== "donation_report" && { donor_id: userId }),
            filters: filters,
            sort: { 
                ...((timeSortDirection  || compensationSortDirection ) &&  {   appointment_time: timeSortDirection,
                    total_price: compensationSortDirection  }),
             
            },
        };
        DonorService.getDonationHistoryList(params)
            .then((response) => {

                setUpcomingDonationList(response.data.list);
                setTotalUpcomingDonation(response.data.total_donation);
                
                setLoading(false);
            })
            .catch((error) => {
                console.error("Failed to fetch UpcomingDonation list", error);
                setLoading(false);
            });
    }
    async function fetchDonationStatus() {
        AdminService.getDonationStatus()
            .then((donationStatusTypes) => {
                setDonationStatus(donationStatusTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch lab locations", error);
            });
    }
    async function fetchSampleTypes() {
        AdminService.getSampleTypes()
            .then((sampleTypes) => {
                setSamples(sampleTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch donation status types", error);
            });
    }

    const handleDonationStatusChange = (donationStatusId) => {
        if (selectedDonationStatus.includes(donationStatusId)) {
            setSelectedDonationStatus(selectedDonationStatus.filter((id) => id !== donationStatusId));
        } else {
            setSelectedDonationStatus([...selectedDonationStatus, donationStatusId]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    const handleSampleChange = (sample) => {
        if (selectedSamples.includes(sample)) {
            setSelectedSamples(selectedSamples.filter((s) => s !== sample));
        } else {
            setSelectedSamples([...selectedSamples, sample]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    const handleDateRangeChange = (daterange) => {
       
        // Set the selected date range directly to the new range array
        setSelectedDateRange(daterange);

        // Reset pagination whenever the date range changes
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    function handleTimeSort(direction) {
        setTimeSortDirection(direction);
        setPagination({ ...pagination, page: 1, offset: 0 });
    }

    function handleCompensationSort(direction) {
        setCompensationSortDirection(direction);
        setPagination({ ...pagination, page: 1, offset: 0 });
    }

    const handleChangeStatus = async (admin, status) => {
        setLoading(true);
        const newStatus = admin.active ? 0 : 1; // Determine the new status
        try {
            const response = await AdminService.changeUserStatus(admin.id, newStatus); // Pass the user ID and new status

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                fetchUpcomingDonationList();
                setLoading(false);

            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);

            }
        } catch (error) {
            setToastMessage("Failed to change user status");
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to change user status:", error);
            setLoading(false);

        }
    };

    const handleDeleteUser = async (userId) => {
        try {

            const response = await AdminService.deleteAdminUser(userId);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("User deleted successfully:", response);
                fetchUpcomingDonationList();
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {
            console.error("Failed to delete user:", error);
        }
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {

        if (newRowsPerPage === 'Show All') {
            setRowsPerPage(totalUpcomingDonations);
            setPagination({ limit: totalUpcomingDonations, offset: 0, page: 1 });
        } else {
            setRowsPerPage(Number(newRowsPerPage));
            setPagination({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
        }
    };

    const totalFiltered = UpcomingDonationList.length;  //ex 10 
    const totalPages = Math.ceil(totalUpcomingDonations / rowsPerPage); // 10 / 2rpp  then  5 pages

    const handleNextPage = () => {
        setPagination({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
    };

    const handlePreviousPage = () => {
        setPagination({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
    };

    function handleTimeSort(direction) {
        setTimeSortDirection(direction);
        setPagination({ ...pagination, page: 1, offset: 0 });
    }
    return (

        <><Loader loading={loading}/>
            <div className="">
                <div className="el-table-container el-board-table">
                    <Table hover className="table table-striped">
                        <thead>
                            <tr>
                                <th>
                                    <DateRangeFilter
                                        selectedDateRange={selectedDateRange}
                                        handleDateRangeChange={handleDateRangeChange}
                                        setSelectedDateRange={setSelectedDateRange}
                                        label={userType=='donation_report' ? "Donate Date": "Date"} /></th>

                                {userType!=="donation_report"  && (
                                    <th>
                                        {/* //component used for sorting time   */}
                                        <NumberOfDonationSort handleSortDonations={handleTimeSort} sortDirection={timeSortDirection} type="time" />
                                    </th>
                                )}
                                 {userType==="donation_report"  && (
                                    <th>
                                        <SearchInput label="Donor Name"
                                    value={searchDonorName}
                                    setValue={setSearchDonorName}
                                    isVisible={isSearchDonorNameInputVisible}
                                    setVisible={setSearchDonorNameInputVisible} /></th>
                             
                                 )}
                                <th><SearchInput label="Job #"
                                    value={searchJob}
                                    setValue={setSearchJob}
                                    isVisible={isSearchInputVisible}
                                    setVisible={setSearchInputVisible} /></th>
                                {/* <th> <SampleTypeDropdown
                                    samples={labLocations}
                                    selectedSamples={selectedLabLocations}
                                    handleSampleChange={handleLabLocationChange}
                                    setSelectedSamples={setSelectedLabLocations}
                                    type="location" /></th> */}

                                <th>
                                    <SampleTypeDropdown
                                        samples={samples}
                                        selectedSamples={selectedSamples}
                                        handleSampleChange={handleSampleChange}
                                        setSelectedSamples={setSelectedSamples} />
                                </th>
                                <th>
                                    <NumberOfDonationSort handleSortDonations={handleCompensationSort} sortDirection={compensationSortDirection} type="compensation" />
                                </th>
                                {/* <th>Blood Volume & Sticks</th> */}
                                <th>
                                    <SampleTypeDropdown
                                        samples={donationStatus}
                                        selectedSamples={selectedDonationStatus}
                                        handleSampleChange={handleDonationStatusChange}
                                        setSelectedSamples={setSelectedDonationStatus}
                                        type={"donationhistory"} />
                                </th>

                                {(userType!=="donor" && userType!=="donation_report" )&& (
                                    <>
                                    <th><FaClock></FaClock></th>
                                    <th>Notes</th>
                                    
                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {UpcomingDonationList.length > 0 ? (UpcomingDonationList.map((Donation, index) => (
                                    <DonationHistoryTableRow
                                        key={index}
                                        donation={Donation}
                                        handleChangeStatus={handleChangeStatus}
                                        handleDeleteUser={handleDeleteUser}
                                        fetchDonorList={fetchUpcomingDonationList}
                                        sampleTypes={samples}
                                        userType={userType}
                                    />
                                ))) : (
                                    <NoListDataAvailable type="donation history" />
                                )}
                        </tbody>
                    </Table>
                </div>
                <TablePagination
                    rowsPerPage={rowsPerPage}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    pagination={pagination}
                    totalPages={totalPages}
                    handlePreviousPage={handlePreviousPage}
                    handleNextPage={handleNextPage}
                    totalUsers={totalUpcomingDonations}
                />
                <Toaster
                    show={showToast}
                    message={toastMessage}
                    variant={toastVariant}
                    onClose={() => setShowToast(false)}
                />
            </div>
        </>
    );
}

export default DonationHistoryListTable;